import { OrientationProps } from '../../Menu/@types/MenuProps';

type StyledLinkContainerProps = {
	children: React.ReactNode;
	orientation?: OrientationProps;
	blockClass?: string;
};

const StyledLinkContainer = ({ children, blockClass, orientation }: StyledLinkContainerProps) => {
	const renderTokens = () => {
		if (orientation === 'vertical') {
			return 'mh6 pv2';
		}

		return 'mh6 pv5';
	};

	return (
		<div
			className={`vtex-menu-2-x-styledLinkContainer styledLinkContainer vtex-menu-2-x-styledLinkContainer--${blockClass} styledLinkContainer--${blockClass} ${renderTokens()}`}
		>
			{children}
		</div>
	);
};

export default StyledLinkContainer;
